(function($) {
	'use strict';
	$.fn.Accordion = function() {
		this.each(function() { 

			/*
			 * Action: Accordion open / close
			 */
			var $self = $(this),
				$content = $self.next('.accordion-content'),
				content_height = $content.height();
				
			
			// First, calculate height of $content
			$content.data('open-height', content_height ).addClass('closed');
				
			// Listen for trigger
			$self.off( $.Globals.clickEvent + '.accordion-trigger' ).on( $.Globals.clickEvent + '.accordion-trigger', function(e) {
				e.preventDefault();
				
				// Close other accordions
				$self.parent().parent().find('.accordion-trigger.open').not( $self ).trigger( $.Globals.clickEvent );
				
				// Trigger
				$self.toggleClass('closed').toggleClass('open');
				
				// Content
				if( $content.hasClass('closed') ) {
					$content.height( $content.data('open-height') );
				} else {
					$content.height( 0 );
				}
				
				// Toggle the class
				$content.toggleClass('closed');
				
			});
		
		});
		return this;
	};
}(jQuery));